// extracted by extract-css-chunks-webpack-plugin
module.exports = {"sm":"576px","md":"768px","lg":"992px","xl":"1230px","xxl":"1600px","xxxl":"2000px"};